import { Component, Input, OnInit } from '@angular/core';
import { Activation, ActivationStatus, AppType } from '@vendasta/marketplace-analytics';

interface Product {
  appName: string;
  appId: string;
  quantity: number;
}

@Component({
  selector: 'app-activation-list',
  templateUrl: './activation-list.component.html',
  styleUrls: ['./activation-list.component.scss'],
})
export class ActivationListComponent implements OnInit {
  @Input() activations: Activation[];
  @Input() businessId: string;
  @Input() productIdToName: Map<string, string>;
  products: Product[];

  ngOnInit(): void {
    this.getProductsList(this.activations, this.productIdToName);
  }

  getProductsList(activations: Activation[], productIdToName: Map<string, string>): void {
    const activeApps = activations.filter(
      (a) => a.activationStatus === ActivationStatus.ACTIVATION_STATUS_ACTIVE && a.appType === AppType.APP_TYPE_APP,
    );
    const productIdToProduct = new Map<string, Product>();
    activeApps.forEach((activeApp) => {
      if (productIdToProduct.has(activeApp.appId)) {
        return;
      }

      const product = {
        appId: activeApp.appId,
        appName: productIdToName.get(activeApp.appId),
        quantity: activeApps.filter((a) => a.appId === activeApp.appId).length,
      };
      productIdToProduct.set(activeApp.appId, product);
    });
    this.products = Array.from(productIdToProduct.values());
  }
}
